import { makeAutoObservable, runInAction } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class AlertConfigStore {
  alertConfigsMap = new Map();
  alertConfigsByObjectId = new Map();
  // seenObjectIds = new Set();
  loading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  getAlertConfig(deviceId) {
    const key = String(deviceId).trim();
    return this.alertConfigsMap.get(key) || null;
  }

  getAlertConfigByObjectId(objectId) {
    const key = String(objectId).trim();
    return this.alertConfigsByObjectId.get(key) || null;
  }

  async fetchAlertConfigById(objectId) {
    const key = String(objectId).trim();
    if (this.alertConfigsByObjectId.has(key)) return;

    this.loading = true;
    this.error = null;

    try {
      const res = await apiHandler.get(`/api/alert-configs/by-id/${key}`);
      runInAction(() => {
        if (res && res.device_id) {
          this.alertConfigsMap.set(String(res.device_id), res);
        }
        this.alertConfigsByObjectId.set(key, res);
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        if (err.response?.status === 404) {
          this.alertConfigsByObjectId.set(key, null);
        } else {
          this.error =
            err.response?.data?.message || "Failed to fetch alert config.";
        }
        this.loading = false;
      });
    }
  }

  async fetchAlertConfig(deviceId) {
    const key = String(deviceId).trim();
    console.log("Here is key: ", key);
    if (this.alertConfigsMap.has(key)) return;

    console.log("🔍 Fetching alert config for:", key);

    this.loading = true;
    this.error = null;

    try {
      const res = await apiHandler.get(`/api/alert-configs/${key}`);
      console.log("Here is response: ", res);
      runInAction(() => {
        // const trueDeviceId = res.device_id;
        this.alertConfigsMap.set(key, res);
        if (res && res.alert_config_id) {
          this.alertConfigsByObjectId.set(String(res.alert_config_id), res);
        }
        this.loading = false;

        console.log("🧠 Stored in map:", this.alertConfigsMap.get(key));
        console.log(
          "🔍 Full map:",
          Object.fromEntries(this.alertConfigsMap.entries())
        );
        console.log("🔑 Keys:", [...this.alertConfigsMap.keys()]);
        console.log("🔍 Map has key?", this.alertConfigsMap.has(key));
      });
    } catch (err) {
      runInAction(() => {
        if (err.response?.status === 404) {
          this.alertConfigsMap.set(key, null);
        } else {
          this.error =
            err.response?.data?.message || "Failed to fetch alert config.";
        }
        this.loading = false;
      });
    }
    // console.log("🔍 Full config map:", Object.fromEntries(this.alertConfigsMap.entries()));
    // console.log("🔍 Map now has:", this.alertConfigsMap.has(key));
    // console.log("🧠 All keys:", [...this.alertConfigsMap.keys()]);
  }

  async createAlertConfig({ device_id, recipients, alertsConfig }) {
    this.loading = true;
    this.error = null;
    try {
      const res = await apiHandler.post(`/api/alert-configs`, {
        device_id,
        recipients,
        alertsConfig,
      });

      runInAction(() => {
        this.alertConfigsMap.set(device_id, res);
        this.alertConfigsByObjectId.set(
          String(res.alert_config_id).trim(),
          res
        );
        this.loading = false;
      });

      return res.data;
    } catch (err) {
      runInAction(() => {
        this.error =
          err.response?.data?.message || "Failed to create alert config.";
        this.loading = false;
      });
    }
  }

  async updateAlertConfig(device_id, updatedData) {
    this.loading = true;
    this.error = null;

    try {
      const res = await apiHandler.put(
        `/api/alert-configs/${device_id}`,
        updatedData
      );

      console.log("Updated alert config from backend: ", res);

      runInAction(() => {
        this.alertConfigsMap.set(String(device_id).trim(), res);

        if (res.alert_config_id) {
          this.alertConfigsByObjectId.set(
            String(res.alert_config_id).trim(),
            res
          );
        }

        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error =
          err.response?.data?.message || "Failed to update alert config.";

        this.loading = false;
      });
    }
  }

  async deleteAlertConfig(device_id) {
    this.loading = true;
    this.error = null;
    try {
      await apiHandler.delete(`/api/alert-configs/${device_id}`);
      runInAction(() => {
        this.alertConfigsMap.delete(device_id);
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error =
          err.response?.data?.message || "Failed to delete alert config.";
        this.loading = false;
      });
    }
  }

  clear() {
    this.alertConfigsMap.clear();
    this.alertConfigsByObjectId.clear();
    this.loading = false;
    this.error = null;
  }
}

const alertConfigStore = new AlertConfigStore();
export default alertConfigStore;
